import { MDXEditorMethods } from "@mdxeditor/editor";
import { HidroDXEditor } from "../edit";
import { useEffect, useRef, useState } from "react";
import { useBarragemContext, useUserContext } from "../../context";
import { Box, IconButton } from "@mui/material";
import { Edit, Save } from "@mui/icons-material";
import { generateRandomHash } from "../../core";
import { RequestError, useApi } from "../../services";
import { ErrorOnDialog } from "../modals";

export const RecursosMateriaisLogisticos: React.FC = () => {
  const api = useApi();
  const user = useUserContext();
  const { barragem, setBarragem } = useBarragemContext();

  const editorRef = useRef<MDXEditorMethods>(null);
  const startText = useRef<string>();
  const textNow = useRef<string>("");

  const [isEditing, setIsEditing] = useState(false);
  const [error, setError] = useState<RequestError>();

  useEffect(() => {
    if (!barragem || "error" in barragem) return;

    startText.current = barragem.recMatLogisticos;
    textNow.current = barragem.recMatLogisticos ?? "";
    editorRef.current?.setMarkdown(barragem.recMatLogisticos ?? "");
  }, [barragem, isEditing]);

  const onSave = () => {
    if (!barragem || "error" in barragem) return;

    api.barragem.updateRecMatLogisticos(barragem.id, textNow.current).then((value) => {
      if ("error" in value) {
        setError(value);
        return;
      }

      setIsEditing(false);
      setBarragem(value);
    });
  };

  if (!barragem || !user || "error" in user || "error" in barragem) {
    return <></>;
  }

  return <>
    {/* Error */}
    {error && <ErrorOnDialog
      open={Boolean(error)}
      error={error.error}
      message={error.message}
      onClose={() => setError(undefined)}
    />}

    <Box sx={{
      width: "100%",
      height: "100%",
      display: "flex",
      flexDirection: "row",
    }}>
      <div style={{
        flex: 1,
        width: "100%",
        height: "100%",
        overflowY: "auto",
        textAlign: "justify",
      }}>
        <HidroDXEditor
          key={generateRandomHash(8)}
          image={false}
          chartMap={false}
          readOnly={!isEditing}
          editorRef={editorRef}
          onChange={(text) => {
            textNow.current = text;
          }}
          diffText={startText.current}
        />
      </div>

      {user.admin && !isEditing && <div style={{ width: "3em", height: "3em" }}>
        <IconButton onClick={() => setIsEditing(true)}>
          <Edit />
        </IconButton>
      </div>}

      {user.admin && isEditing && <div style={{ width: "3em", height: "3em" }}>
        <IconButton onClick={() => onSave()}>
          <Save />
        </IconButton>
      </div>}
    </Box>
  </>;
};
